/*
  File: cabinet-configurator.js
  Place this file in: assets/cabinet-configurator.js
*/

(function() {
  'use strict';

  // Load pricing data
  let pricingData = null;

  // Blind corner cabinet types (require Door Side selection)
  const BLIND_CORNER_TYPES = ['Wall Blind Corner', 'Base Blind Corner'];

  // State
  let config = {
    type: '',
    material: '',
    style: '',
    color: '',
    width: '',
    height: '',
    depth: '',
    doorSide: '',
    handle: '',
    position: ''
  };

  let cabinetList = [];

  const STORAGE_KEY = 'cabinetList';

  // Door style options per material
  const doorStyles = {
    "Melamine": [
      {value: "Slab", label: "Plain Slab Door", icon: "slab"}
    ],
    "Thermofoil": [
      {value: "Profile1", label: "Profile 1", icon: "profile1"},
      {value: "Profile2", label: "Profile 2", icon: "profile2"},
      {value: "Profile3", label: "Profile 3", icon: "profile3"}
    ],
    "High Gloss": [
      {value: "Slab", label: "Plain Slab Door", icon: "slab"}
    ]
  };

  // Color options per material
  const colorOptions = {
    "Melamine":   ["White", "Grey", "Espresso"],
    "Thermofoil": ["White", "Grey", "Espresso"],
    "High Gloss": ["White", "Modern Grey", "Fume"]
  };

  const colorSwatchClass = {
    "White": "white",
    "Grey": "grey",
    "Espresso": "espresso",
    "Modern Grey": "modern-grey",
    "Fume": "fume"
  };

  // Per-type dimension ranges (width + height)
  const typeConfig = {
    "Wall":              { width: {min: 6,  max: 40, step: 0.25}, height: {min: 24,    max: 40, step: 0.25, standard: 24} },
    "Wall Corner 45":    { width: {fixed: [22, 24]},               height: {min: 24,    max: 40, step: 0.25, standard: 24} },
    "Wall Blind Corner": { width: {min: 26, max: 32, step: 0.25}, height: {min: 24,    max: 40, step: 0.25, standard: 24} },
    "Base":              { width: {min: 6,  max: 36, step: 0.25}, height: {min: 35.25, max: 48, step: 0.25, standard: 35.25} },
    "Base Sink":         { width: {min: 18, max: 36, step: 0.25}, height: {min: 35.25, max: 48, step: 0.25, standard: 35.25} },
    "Base Drawer 3":     { width: {min: 6,  max: 36, step: 0.25}, height: {min: 35.25, max: 48, step: 0.25, standard: 35.25} },
    "Base Drawer 4":     { width: {min: 6,  max: 36, step: 0.25}, height: {min: 35.25, max: 48, step: 0.25, standard: 35.25} },
    "Base Drawer Top":   { width: {min: 6,  max: 36, step: 0.25}, height: {min: 35.25, max: 48, step: 0.25, standard: 35.25} },
    "Base Blind Corner": { width: {min: 38, max: 46, step: 0.25}, height: {min: 35.25, max: 48, step: 0.25, standard: 35.25} },
    "Base Corner":       { width: {fixed: [33, 34, 36]},          height: {fixed: [35.25]} },
    "Pantry":            { width: {min: 8,  max: 30, step: 0.25}, height: {min: 84,    max: 96, step: 0.25, standard: 84} },
    "Fridge":            { width: {min: 24, max: 38, step: 0.25}, height: {min: 12,    max: 18, step: 0.25, standard: 12} },
    "Microwave":         { width: {min: 24, max: 24, step: 0.25}, height: {min: 24,    max: 40, step: 0.25, standard: 24} }
  };

  // Base types that use height-tier multipliers
  const BASE_TYPES = ['Base', 'Base Sink', 'Base Drawer 3', 'Base Drawer 4',
                      'Base Drawer Top', 'Base Blind Corner'];

  // Height tier multipliers for Base types (cumulative, above standard 35.25")
  const BASE_HEIGHT_TIERS = [
    {above: 35.25, multiplier: 1.10},
    {above: 40.00, multiplier: 1.20},
    {above: 44.00, multiplier: 1.30}
  ];

  // Depth configuration per cabinet type
  const BASE_DEPTH_TIERS = [
    {above: 24, multiplier: 1.10},
    {above: 26, multiplier: 1.15},
    {above: 28, multiplier: 1.20}
  ];
  const WALL_DEPTH_TIERS = [
    {above: 12, multiplier: 1.10},
    {above: 14, multiplier: 1.15}
  ];
  const depthConfig = {
    "Wall":              {standard: 12, min: 12, max: 16, step: 0.25, tiers: WALL_DEPTH_TIERS},
    "Wall Corner 45":    {standard: 12, min: 12, max: 16, step: 0.25, tiers: WALL_DEPTH_TIERS},
    "Wall Blind Corner": {standard: 12, min: 12, max: 16, step: 0.25, tiers: WALL_DEPTH_TIERS},
    "Base":              {standard: 24, min: 24, max: 30, step: 0.25, tiers: BASE_DEPTH_TIERS},
    "Base Sink":         {standard: 24, min: 24, max: 30, step: 0.25, tiers: BASE_DEPTH_TIERS},
    "Base Drawer 3":     {standard: 24, min: 24, max: 30, step: 0.25, tiers: BASE_DEPTH_TIERS},
    "Base Drawer 4":     {standard: 24, min: 24, max: 30, step: 0.25, tiers: BASE_DEPTH_TIERS},
    "Base Drawer Top":   {standard: 24, min: 24, max: 30, step: 0.25, tiers: BASE_DEPTH_TIERS},
    "Base Blind Corner": {standard: 24, min: 24, max: 30, step: 0.25, tiers: BASE_DEPTH_TIERS},
    "Base Corner":       {standard: 24, fixed: [24]},
    "Pantry":            {standard: 24, fixed: [24]},
    "Fridge":            {standard: 12, fixed: [12, 24]},
    "Microwave":         {standard: 12, fixed: [12]}
  };

  // Material display labels
  const materialLabels = {
    "Melamine":   "Melamine Doors",
    "Thermofoil": "Thermofoil MDF Doors",
    "High Gloss": "High Gloss MDF Doors"
  };

  // ── Persistence ──────────────────────────────────────────────

  function saveList() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cabinetList));
    } catch(e) {}
  }

  function loadList() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) cabinetList = JSON.parse(saved);
    } catch(e) {
      cabinetList = [];
    }
  }

  // ── Pricing data ─────────────────────────────────────────────

  async function loadPricingData() {
    // Inline data takes precedence (used by offline HTML to avoid fetch)
    if (window.cabinetPricingData) {
      pricingData = window.cabinetPricingData;
      return;
    }
    try {
      const url = (window.cabinetConfig && window.cabinetConfig.pricingUrl)
        ? window.cabinetConfig.pricingUrl
        : '/cdn/shop/t/' + Shopify.theme.id + '/assets/cabinet-pricing.json?v=' + Date.now();
      const response = await fetch(url);
      pricingData = await response.json();
    } catch (error) {
      console.error('Error loading pricing data:', error);
      pricingData = {"Wall":{"24":{"6":65.1,"8":72.45,"10":78.75,"12":85.05,"14":92.4,"16":98.7,"18":105,"20":112.35,"22":119.7,"24":131.25,"26":138.6,"28":145.95,"30":152.25,"32":158.55,"34":165.9,"36":173.25,"38":180.6,"40":189},"28":{"6":71.4,"8":76.65,"10":82.95,"12":89.25,"14":98.175,"16":106.05,"18":113.4,"20":121.8,"22":129.15,"24":142.8,"26":150.675,"28":158.55,"30":165.9,"32":175.35,"34":183.225,"36":189,"38":199.5,"40":210},"30":{"6":75.6,"8":84,"10":92.4,"12":100.8,"14":109.2,"16":117.6,"18":126,"20":134.4,"22":142.8,"24":159.6,"26":168,"28":176.4,"30":184.8,"32":193.2,"34":201.6,"36":210,"38":218.4,"40":226.8},"32":{"6":77,"8":87,"10":96,"12":105,"14":114,"16":123,"18":132,"20":141,"22":150,"24":159,"26":168,"28":177,"30":186,"32":195,"34":204,"36":213,"38":222,"40":231},"34":{"6":78.75,"8":89.25,"10":98.7,"12":108.15,"14":117.6,"16":127.05,"18":136.5,"20":145.95,"22":155.4,"24":171.15,"26":179.55,"28":189,"30":199.5,"32":207.9,"34":217.35,"36":226.8,"38":236.25,"40":245.7},"36":{"6":84,"8":92.4,"10":102.9,"12":112.35,"14":122.85,"16":132.3,"18":141.75,"20":152.25,"22":161.7,"24":176.4,"26":185.85,"28":196.35,"30":205.8,"32":215.25,"34":225.75,"36":235.2,"38":244.65,"40":254.1},"38":{"6":90,"8":96,"10":105,"12":117,"14":128,"16":139,"18":146,"20":160,"22":168,"24":183,"26":192,"28":203,"30":212,"32":222,"34":232,"36":242,"38":252,"40":261},"40":{"6":96,"8":99,"10":109,"12":121,"14":132,"16":143,"18":154,"20":165,"22":176,"24":193,"26":205,"28":215,"30":226,"32":238,"34":249,"36":260,"38":271,"40":282}},"Wall Corner 45":{"22x22":{"24":184.8,"28":205.8,"30":223.65,"32":231,"34":238.35,"36":245.7,"38":256.2,"40":266.7},"24x24":{"24":205.8,"28":226.8,"30":244.65,"32":252,"34":259.35,"36":266.7,"38":277.2,"40":287.7}},"Wall Blind Corner":{"26":{"24":138.6,"28":154.35,"30":164.85,"32":170.1,"34":175.35,"36":180.6,"38":185.85,"40":196.35},"28":{"24":145.95,"28":161.7,"30":173.25,"32":178.5,"34":184.8,"36":191.1,"38":196.35,"40":206.85},"30":{"24":153.3,"28":169.05,"30":181.65,"32":187.95,"34":195.3,"36":200.55,"38":205.8,"40":216.3},"32":{"24":159.6,"28":175.35,"30":191.1,"32":196.35,"34":203.7,"36":211.05,"38":216.3,"40":226.8}},"Base":{"6":115.5,"8":123.9,"10":132.3,"12":141.75,"14":151.2,"16":159.6,"18":169.05,"20":177.45,"22":187.95,"24":202.65,"26":211.05,"28":220.5,"30":229.95,"32":238.35,"34":246.75,"36":257.25},"Base Sink":{"18":164.85,"24":175.35,"30":196.35,"34":208.95,"36":216.3},"Base Drawer 3":{"12":284.55,"14":298.2,"16":311.85,"18":324.45,"20":338.1,"22":351.75,"24":365.4,"26":379.05,"28":391.65,"30":406.35,"32":420,"34":432.6,"36":446.25},"Base Drawer 4":{"12":326.55,"14":340.2,"16":353.85,"18":366.45,"20":380.1,"22":393.75,"24":407.4,"26":421.05,"28":433.65,"30":448.35,"32":462,"34":474.6,"36":488.25},"Base Drawer Top":{"12":181.65,"14":192.15,"16":203.7,"18":214.2,"20":225.75,"22":236.25,"24":253.05,"26":263.55,"28":274.05,"30":285.6,"32":296.1,"34":306.6,"36":317.1},"Base Blind Corner":{"38":262.5,"40":294,"42":325.5,"44":357,"46":388.5},"Base Corner":{"33x33":320.25,"34x34":341.25,"36x36":362.25},"Pantry":{"8":286.65,"10":316.05,"12":345.45,"14":374.85,"16":404.25,"18":432.6,"20":462,"22":490.35,"24":531.3,"26":559.65,"28":588,"30":617.4},"Fridge":{"12":{"24":{"12":87.15,"14":96.6,"16":100.8,"18":105},"30":{"12":98.7,"14":110.25,"16":115.5,"18":120.75},"32":{"12":102.9,"14":114.45,"16":120.75,"18":124.95},"36":{"12":110.25,"14":122.85,"16":130.2,"18":134.4},"38":{"12":117.6,"14":133.35,"16":140.7,"18":144.9}},"24":{"24":{"12":114.45,"14":124.95,"16":131.25,"18":136.5},"30":{"12":130.2,"14":143.85,"16":151.2,"18":156.45},"32":{"12":135.45,"14":150.15,"16":156.45,"18":162.75},"36":{"12":145.95,"14":161.7,"16":168,"18":175.35},"38":{"12":156.45,"14":172.2,"16":178.5,"18":185.85}}},"Microwave":{"24":114.45,"28":123.9,"30":131.25,"34":143.85,"36":150.15,"38":159.6,"40":168}};
    }
  }

  // ── Width options ─────────────────────────────────────────────

  function initWidthOptions() {
    const select = document.getElementById('width');
    if (!select) return;
    const tc = typeConfig[config.type];
    if (!tc) return;
    select.innerHTML = '<option value="">-- Choose --</option>';
    if (tc.width.fixed) {
      tc.width.fixed.forEach(w => {
        const opt = document.createElement('option');
        opt.value = String(w);
        opt.textContent = w + ' x ' + w + '"';
        select.appendChild(opt);
      });
    } else {
      const {min, max, step} = tc.width;
      for (let w = min; w <= max + 0.001; w += step) {
        const val = parseFloat(w.toFixed(4));
        const opt = document.createElement('option');
        opt.value = val.toFixed(2);
        opt.textContent = val.toFixed(2) + '"';
        select.appendChild(opt);
      }
    }
  }

  // ── Height options ────────────────────────────────────────────

  function initHeightOptions() {
    const select = document.getElementById('height');
    if (!select) return;
    const tc = typeConfig[config.type];
    if (!tc) return;
    select.innerHTML = '';
    if (tc.height.fixed) {
      tc.height.fixed.forEach(h => {
        const val = parseFloat(h);
        const opt = document.createElement('option');
        opt.value = val.toFixed(2);
        opt.textContent = val.toFixed(2) + '" (Standard)';
        select.appendChild(opt);
      });
      select.value = parseFloat(tc.height.fixed[0]).toFixed(2);
      config.height = select.value;
      return;
    }
    const {min, max, step, standard} = tc.height;
    for (let h = min; h <= max + 0.001; h += step) {
      const val = parseFloat(h.toFixed(4));
      const opt = document.createElement('option');
      opt.value = val.toFixed(2);
      opt.textContent = val.toFixed(2) + '"' + (val === standard ? ' (Standard)' : '');
      select.appendChild(opt);
    }
    select.value = standard.toFixed(2);
    config.height = select.value;
  }

  // ── Depth options ─────────────────────────────────────────────

  function initDepthOptions(type) {
    const select = document.getElementById('depth');
    const label = document.getElementById('depthStandardLabel');
    if (!select) return;
    const dc = depthConfig[type];
    select.innerHTML = '';
    if (!dc) { config.depth = ''; return; }
    if (label) label.textContent = `(Standard: ${dc.standard}")`;
    if (dc.fixed) {
      dc.fixed.forEach(d => {
        const opt = document.createElement('option');
        opt.value = d;
        opt.textContent = d + '"' + (d === dc.standard ? ' (Standard)' : '');
        select.appendChild(opt);
      });
    } else {
      for (let d = dc.min; d <= dc.max + 0.001; d += dc.step) {
        const val = parseFloat(d.toFixed(4));
        const opt = document.createElement('option');
        opt.value = val.toFixed(2);
        opt.textContent = val.toFixed(2) + '"' + (val === dc.min ? ' (Standard)' : '');
        select.appendChild(opt);
      }
    }
    select.value = dc.fixed ? String(dc.standard) : dc.standard.toFixed(2);
    config.depth = select.value;
  }

  // ── Pricing calculations ──────────────────────────────────────

  // Linear interpolation between numeric-string-keyed table entries
  function interpolateBetweenKeys(table, value) {
    const keys = Object.keys(table).map(Number).sort((a, b) => a - b);
    const v = parseFloat(value);
    if (v <= keys[0]) return table[String(keys[0])];
    if (v >= keys[keys.length - 1]) return table[String(keys[keys.length - 1])];
    let lo = keys[0], hi = keys[1];
    for (let i = 0; i < keys.length - 1; i++) {
      if (v >= keys[i] && v <= keys[i + 1]) { lo = keys[i]; hi = keys[i + 1]; break; }
    }
    const ratio = (v - lo) / (hi - lo);
    return table[String(lo)] + ratio * (table[String(hi)] - table[String(lo)]);
  }

  // Thermofoil base price in dollars from the JSON (bilinear for Wall, width-only for Base)
  function lookupThermofoilDollars(type, width, height) {
    if (!pricingData || !pricingData[type]) return 100;
    const data = pricingData[type];

    if (type === 'Wall') {
      // Bilinear: outer keys = height anchors, inner keys = width
      const heightKeys = Object.keys(data).map(Number).sort((a, b) => a - b);
      const h = parseFloat(height);
      const hLo = heightKeys.reduce((p, c) => c <= h ? c : p, heightKeys[0]);
      const hHi = heightKeys.find(k => k >= h) || heightKeys[heightKeys.length - 1];
      const priceAtHLo = interpolateBetweenKeys(data[String(hLo)], width);
      if (hLo === hHi) return priceAtHLo;
      const priceAtHHi = interpolateBetweenKeys(data[String(hHi)], width);
      return priceAtHLo + ((h - hLo) / (hHi - hLo)) * (priceAtHHi - priceAtHLo);
    } else if (type === 'Wall Blind Corner') {
      // Bilinear: outer keys = width anchors, inner keys = height
      const widthKeys = Object.keys(data).map(Number).sort((a, b) => a - b);
      const w = parseFloat(width);
      const wLo = widthKeys.reduce((p, c) => c <= w ? c : p, widthKeys[0]);
      const wHi = widthKeys.find(k => k >= w) || widthKeys[widthKeys.length - 1];
      const priceAtWLo = interpolateBetweenKeys(data[String(wLo)], height);
      if (wLo === wHi) return priceAtWLo;
      const priceAtWHi = interpolateBetweenKeys(data[String(wHi)], height);
      return priceAtWLo + ((w - wLo) / (wHi - wLo)) * (priceAtWHi - priceAtWLo);
    } else if (type === 'Wall Corner 45') {
      // width is "22" or "24" → map to "22x22" or "24x24" size key
      const w = Math.round(parseFloat(width));
      const sizeData = data[w + 'x' + w] || Object.values(data)[0];
      if (!sizeData) return 100;
      return interpolateBetweenKeys(sizeData, height);
    } else if (type === 'Base Corner') {
      // width is "33", "34", or "36" → direct lookup by "33x33" etc.
      const w = Math.round(parseFloat(width));
      return data[w + 'x' + w] || 100;
    } else {
      // Width-only interpolation (Base types, Pantry, etc.)
      return interpolateBetweenKeys(data, width);
    }
  }

  // Height tier multiplier for Base cabinet types
  function getHeightMultiplier(height, type) {
    if (!BASE_TYPES.includes(type)) return 1.0;
    const h = parseFloat(height);
    let multiplier = 1.0;
    for (const tier of BASE_HEIGHT_TIERS) {
      if (h > tier.above) multiplier = tier.multiplier;
      else break;
    }
    return multiplier;
  }

  function getDepthMultiplier(depth, type) {
    const dc = depthConfig[type];
    if (!dc || !dc.tiers || dc.tiers.length === 0) return 1.0;
    const d = parseFloat(depth);
    let multiplier = 1.0;
    for (const tier of dc.tiers) {
      if (d > tier.above) multiplier = tier.multiplier;
      else break;
    }
    return multiplier;
  }

  function calculatePrice(cfg = config) {
    if (!cfg.type || !cfg.material || !cfg.width || !cfg.height || !cfg.depth) return 0;
    // 1. Thermofoil base price (dollars → cents)
    let cents = Math.ceil(lookupThermofoilDollars(cfg.type, cfg.width, cfg.height)) * 100;
    // 2. Material multiplier
    if (cfg.material === 'Melamine')    cents = Math.round(cents * 0.85);
    else if (cfg.material === 'High Gloss') cents = Math.round(cents * 1.20);
    // 3. Height tier multiplier (Base types only)
    cents = Math.round(cents * getHeightMultiplier(cfg.height, cfg.type));
    // 4. Depth tier multiplier
    cents = Math.round(cents * getDepthMultiplier(parseFloat(cfg.depth), cfg.type));
    return Math.ceil(cents / 100) * 100;
  }

  // ── SKU generation ────────────────────────────────────────────

  function generateSKU() {
    if (!config.type || !config.material || !config.style || !config.color || !config.width || !config.height || !config.depth) {
      return '-';
    }
    const isBlind = BLIND_CORNER_TYPES.includes(config.type);
    if (isBlind && !config.doorSide) return '-';
    const w = (parseFloat(config.width) * 100).toFixed(0);
    const h = (parseFloat(config.height) * 100).toFixed(0);
    const d = (parseFloat(config.depth) * 100).toFixed(0);
    const typeCode = config.type.split(' ')[0].toUpperCase();
    const matCode = config.material === 'Melamine' ? 'ML' : config.material === 'Thermofoil' ? 'TF' : 'HG';
    const styleCode = config.style.substring(0, 3).toUpperCase();
    const colorCode = config.color.replace(/\s+/g, '').substring(0, 3).toUpperCase();
    const handleCode = config.handle ? config.handle.substring(0, 3).toUpperCase() : '';
    const posCode = config.position ? config.position.charAt(0).toUpperCase() : '';
    const dsCode = isBlind ? '-' + config.doorSide.charAt(0).toUpperCase() : '';
    return `${typeCode}-${matCode}-${styleCode}-${w}x${h}x${d}-${colorCode}-${handleCode}-${posCode}${dsCode}`;
  }

  // ── UI helpers ────────────────────────────────────────────────

  function updateSummary() {
    const summaryConfig = document.getElementById('summaryConfig');
    const skuDisplay = document.getElementById('skuDisplay');
    const priceAmount = document.getElementById('priceAmount');
    const addCabinetBtn = document.getElementById('addCabinetBtn');
    if (!summaryConfig || !skuDisplay || !priceAmount || !addCabinetBtn) return;

    const isBlind = BLIND_CORNER_TYPES.includes(config.type);
    let configText = '-';
    if (config.width && config.height && config.depth && config.type && config.material && config.color && config.handle && config.position && (!isBlind || config.doorSide)) {
      const matLabel = materialLabels[config.material] || config.material;
      const dsText = isBlind ? `, Door Side - ${config.doorSide}` : '';
      const noBackText = config.type === 'Base Sink' ? ', No Back' : '';
      configText = `${config.width}" W x ${config.height}" H x ${config.depth}" D, ${config.type} Cabinet, ${matLabel} - ${config.color}${dsText}${noBackText}, ${config.handle} Handle, Handle Position - ${config.position}`;
    }
    summaryConfig.textContent = configText;

    skuDisplay.textContent = generateSKU();

    const price = calculatePrice();
    priceAmount.textContent = (price / 100).toFixed(2);

    const isComplete = config.type && config.material && config.style && config.color &&
                       config.width && config.height && config.depth && config.handle && config.position &&
                       (!isBlind || config.doorSide);
    addCabinetBtn.disabled = !isComplete;
  }

  function activateStep(stepNum) {
    const step = document.getElementById(`step${stepNum}`);
    if (step) step.classList.add('active');
  }

  // ── Event handlers ────────────────────────────────────────────

  function handleCabinetTypeChange() {
    const select = document.getElementById('cabinetType');
    if (!select) return;
    config.type = select.value;
    config.width = '';
    config.depth = '';
    config.doorSide = '';

    const step8El = document.getElementById('step8');
    if (step8El) {
      if (BLIND_CORNER_TYPES.includes(config.type)) {
        step8El.style.display = '';
        activateStep(8);
        config.doorSide = 'Right';
        const doorSideSelect = document.getElementById('doorSide');
        if (doorSideSelect) doorSideSelect.value = 'Right';
      } else {
        step8El.style.display = 'none';
        step8El.classList.remove('active');
      }
    }

    if (config.type) {
      initWidthOptions();
      initHeightOptions();
      initDepthOptions(config.type);
      activateStep(2);
      activateStep(7);
    }
    updateSummary();
  }

  function handleMaterialChange() {
    const select = document.getElementById('doorMaterial');
    if (!select) return;
    config.material = select.value;
    config.style = '';
    config.color = '';

    if (config.material) {
      // Populate door styles
      const styleContainer = document.getElementById('doorStyleOptions');
      if (styleContainer) {
        styleContainer.innerHTML = '';
        doorStyles[config.material].forEach(style => {
          const div = document.createElement('div');
          div.className = 'visual-option';
          div.dataset.style = style.value;
          div.innerHTML = `<div class="door-icon ${style.icon}"></div>
                           <div class="option-label">${style.label}</div>`;
          styleContainer.appendChild(div);
        });
      }

      // Populate colors
      const colorContainer = document.getElementById('colorOptions');
      if (colorContainer) {
        colorContainer.innerHTML = '';
        colorOptions[config.material].forEach(color => {
          const div = document.createElement('div');
          div.className = 'visual-option';
          div.dataset.color = color;
          div.innerHTML = `<div class="color-swatch ${colorSwatchClass[color]}"></div>
                           <div class="option-label">${color}</div>`;
          colorContainer.appendChild(div);
        });
      }

      activateStep(3);
    }
    updateSummary();
  }

  function selectDoorStyle(element, value) {
    config.style = value;
    const container = document.getElementById('doorStyleOptions');
    if (container) {
      container.querySelectorAll('.visual-option').forEach(opt => opt.classList.remove('selected'));
    }
    element.classList.add('selected');
    activateStep(4);
    updateSummary();
  }

  function selectColor(element, value) {
    config.color = value;
    const colorContainer = document.getElementById('colorOptions');
    if (colorContainer) {
      colorContainer.querySelectorAll('.visual-option').forEach(opt => opt.classList.remove('selected'));
    }
    element.classList.add('selected');
    activateStep(5);
    updateSummary();
  }

  function handleChange() {
    const widthSelect    = document.getElementById('width');
    const heightSelect   = document.getElementById('height');
    const depthSelect    = document.getElementById('depth');
    const doorSideSelect = document.getElementById('doorSide');
    const handleSelect   = document.getElementById('handle');
    const positionSelect = document.getElementById('position');
    if (widthSelect)    config.width    = widthSelect.value;
    if (heightSelect)   config.height   = heightSelect.value;
    if (depthSelect)    config.depth    = depthSelect.value;
    if (doorSideSelect) config.doorSide = doorSideSelect.value;
    if (handleSelect)   config.handle   = handleSelect.value;
    if (positionSelect) config.position = positionSelect.value;
    if (config.width)  activateStep(6);
    if (config.height) activateStep(7);
    if (config.depth) {
      if (BLIND_CORNER_TYPES.includes(config.type)) activateStep(8);
      else activateStep(9);
    }
    if (config.doorSide && BLIND_CORNER_TYPES.includes(config.type)) activateStep(9);
    if (config.handle)  activateStep(10);
    updateSummary();
  }

  // ── Cabinet list ──────────────────────────────────────────────

  function addCabinet() {
    const item = {
      sku: generateSKU(),
      config: {...config},
      price: calculatePrice()
    };
    cabinetList.push(item);
    saveList();
    updateCabinetList();
    const msg = document.getElementById('successMessage');
    if (msg) {
      msg.classList.add('show');
      setTimeout(() => msg.classList.remove('show'), 3000);
    }
  }

  function updateCabinetList() {
    const tbody = document.getElementById('cabinetListBody');
    const cartActions = document.getElementById('cartActions');
    const clearAllBtn = document.getElementById('clearAllBtn');
    const totalAmount = document.getElementById('totalAmount');
    if (!tbody) return;

    if (cabinetList.length === 0) {
      tbody.innerHTML = '<tr><td colspan="5" class="list-empty">No cabinets added yet</td></tr>';
      if (cartActions) cartActions.style.display = 'none';
      if (clearAllBtn) clearAllBtn.style.display = 'none';
      return;
    }

    if (cartActions) cartActions.style.display = 'flex';
    if (clearAllBtn) clearAllBtn.style.display = 'block';

    tbody.innerHTML = '';
    let total = 0;
    cabinetList.forEach((item, index) => {
      const tr = document.createElement('tr');
      const matLabel = materialLabels[item.config.material] || item.config.material;
      const itemIsBlind = BLIND_CORNER_TYPES.includes(item.config.type);
      const itemDsText = itemIsBlind ? `, Door Side - ${item.config.doorSide}` : '';
      const configText = `${item.config.width}" W x ${item.config.height}" H x ${item.config.depth}" D, ${item.config.type} Cabinet, ${matLabel} - ${item.config.color}${itemDsText}, ${item.config.handle} Handle, Handle Position - ${item.config.position}`;
      tr.innerHTML = `
        <td>${index + 1}</td>
        <td style="font-family: 'Courier New', monospace; font-size: 12px;">${item.sku}</td>
        <td>${configText}</td>
        <td style="text-align: right; font-weight: 600;">$${(item.price / 100).toFixed(2)}</td>
        <td style="text-align: center;">
          <button class="remove-item-btn" data-index="${index}">Remove</button>
        </td>
      `;
      tbody.appendChild(tr);
      total += item.price;
    });
    if (totalAmount) totalAmount.textContent = `$${(total / 100).toFixed(2)}`;
  }

  function removeItem(index) {
    cabinetList.splice(index, 1);
    saveList();
    updateCabinetList();
  }

  function clearAll() {
    if (confirm('Are you sure you want to clear all cabinets?')) {
      cabinetList = [];
      saveList();
      updateCabinetList();
    }
  }

  // ── Cart integration ──────────────────────────────────────────

  async function addAllToCart() {
    if (cabinetList.length === 0) return;
    const addToCartBtn = document.getElementById('addToCartBtn');
    if (addToCartBtn) {
      addToCartBtn.textContent = 'Adding to Cart...';
      addToCartBtn.disabled = true;
    }

    try {
      const baseVariantId = window.cabinetConfig?.baseVariantId;
      if (!baseVariantId) {
        alert('Configuration error: Base product variant ID not set. Please contact support.');
        return;
      }

      // Build all items first, then send as a single batch request so the
      // minimum-order plugin only evaluates the cart once (full order total).
      const items = [];
      for (const item of cabinetList) {
        const matLabel = materialLabels[item.config.material] || item.config.material;
        const cartIsBlind = BLIND_CORNER_TYPES.includes(item.config.type);
        const cartDsText = cartIsBlind ? `, Door Side - ${item.config.doorSide}` : '';
        const cartNoBackText = item.config.type === 'Base Sink' ? ', No Back' : '';
        // Price integrity check — re-derive from stored config to detect DOM/heap manipulation
        const expectedPrice = calculatePrice(item.config);
        if (expectedPrice !== item.price) {
          throw new Error(
            `Price integrity check failed for cabinet ${item.sku}. ` +
            `Expected ${expectedPrice} cents, stored ${item.price} cents.`
          );
        }
        const quantity = Math.round(item.price / 100);
        items.push({
          id: baseVariantId,
          quantity: quantity,
          properties: {
            '_line_id': Date.now() + '-' + Math.random().toString(36).slice(2, 7),
            'SKU': item.sku,
            'Configuration': `${item.config.width}" W x ${item.config.height}" H x ${item.config.depth}" D, ${item.config.type} Cabinet, ${matLabel} - ${item.config.color}${cartDsText}${cartNoBackText}, ${item.config.handle} Handle, Handle Position - ${item.config.position}`,
            'Cabinet Type': `${item.config.type} Cabinet`,
            'Door Material': matLabel,
            'Door Style': item.config.style,
            'Color': item.config.color,
            'Width': `${item.config.width}"`,
            'Height': `${item.config.height}"`,
            'Depth': `${item.config.depth}"`,
            ...(cartIsBlind ? {'Door Side': item.config.doorSide} : {}),
            ...(item.config.type === 'Base Sink' ? {'Construction Note': 'No Back'} : {}),
            'Handle': item.config.handle,
            'Position': item.config.position,
            '_display_price': `$${(item.price / 100).toFixed(2)}`
          }
        });
      }

      const response = await fetch(window.cabinetConfig.cartAddUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Failed to add items to cart');

      cabinetList = [];
      saveList();
      window.location.href = window.cabinetConfig.cartUrl;

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding items to cart. Please try again.');
      if (addToCartBtn) {
        addToCartBtn.textContent = 'Add All to Cart';
        addToCartBtn.disabled = false;
      }
    }
  }

  // ── Event delegation ──────────────────────────────────────────

  function setupEventDelegation() {
    const cabinetListBody = document.getElementById('cabinetListBody');
    if (cabinetListBody) {
      cabinetListBody.addEventListener('click', function(e) {
        if (e.target.classList.contains('remove-item-btn')) {
          removeItem(parseInt(e.target.dataset.index));
        }
      });
    }

    const doorStyleOptions = document.getElementById('doorStyleOptions');
    if (doorStyleOptions) {
      doorStyleOptions.addEventListener('click', function(e) {
        const option = e.target.closest('.visual-option');
        if (option && option.dataset.style) selectDoorStyle(option, option.dataset.style);
      });
    }

    const colorOptionsEl = document.getElementById('colorOptions');
    if (colorOptionsEl) {
      colorOptionsEl.addEventListener('click', function(e) {
        const option = e.target.closest('.visual-option');
        if (option && option.dataset.color) selectColor(option, option.dataset.color);
      });
    }
  }

  // ── Init ──────────────────────────────────────────────────────

  async function init() {
    await loadPricingData();
    loadList();
    initWidthOptions();
    initHeightOptions();
    setupEventDelegation();
    updateSummary();
    updateCabinetList();

    const cabinetTypeSelect = document.getElementById('cabinetType');
    if (cabinetTypeSelect) cabinetTypeSelect.addEventListener('change', handleCabinetTypeChange);

    const doorMaterialSelect = document.getElementById('doorMaterial');
    if (doorMaterialSelect) doorMaterialSelect.addEventListener('change', handleMaterialChange);

    const widthSelect    = document.getElementById('width');
    const heightSelect   = document.getElementById('height');
    const depthSelect    = document.getElementById('depth');
    const doorSideSelect = document.getElementById('doorSide');
    const handleSelect   = document.getElementById('handle');
    const positionSelect = document.getElementById('position');
    [widthSelect, heightSelect, depthSelect, doorSideSelect, handleSelect, positionSelect].forEach(select => {
      if (select) select.addEventListener('change', handleChange);
    });

    const addCabinetBtn = document.getElementById('addCabinetBtn');
    if (addCabinetBtn) addCabinetBtn.addEventListener('click', addCabinet);

    const clearAllBtn = document.getElementById('clearAllBtn');
    if (clearAllBtn) clearAllBtn.addEventListener('click', clearAll);

    const addToCartBtn = document.getElementById('addToCartBtn');
    if (addToCartBtn) addToCartBtn.addEventListener('click', addAllToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
